import { useEffect, useState } from "react";
import { loadCatalog } from "@/data/catalog";
import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { WishlistProvider } from "@/context/WishlistContext";
import Wishlist from "@/pages/Wishlist";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { BackToTop } from "@/components/BackToTop";
import Home from "@/pages/Home";
import EShop from "@/pages/EShop";
import Category from "@/pages/Category";
import Product from "@/pages/Product";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Account from "@/pages/Account";
import Search from "@/pages/Search";
import { Login, Register } from "@/pages/Auth";

const FirstEntry = () => {
  const { pathname } = useLocation();
  const nav = useNavigate();
  useEffect(() => {
    if (sessionStorage.getItem("nv_visited")) return;
    sessionStorage.setItem("nv_visited", "1");
    if (pathname === "/eshop") nav("/", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0 }); }, [pathname]);
  return null;
};

const CatalogGate = ({ children }) => {
  const [state, setState] = useState("loading");
  useEffect(() => { loadCatalog().then(() => setState("ok")).catch(() => setState("error")); }, []);
  if (state === "ok") return children;
  return (
    <div data-testid="catalog-loading" className="grid min-h-screen place-items-center bg-[#0a0a0a] text-white">
      <div className="flex flex-col items-center gap-4">
        <img src="/brand/icon.png" alt="NINJAVITY" className={`h-24 w-24 ${state === "loading" ? "animate-pulse" : "opacity-40"}`} />
        {state === "error" && <button onClick={() => window.location.reload()} className="nv-btn-lime !px-5 !py-2.5 text-xs">Riprova / Retry</button>}
      </div>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <CatalogGate>
      <AuthProvider>
        <CartProvider>
          <WishlistProvider>
          <BrowserRouter>
            <FirstEntry />
            <ScrollTop />
            <Header />
            <div className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/eshop" element={<EShop />} />
                <Route path="/c/:cat" element={<Category />} />
                <Route path="/p/:code" element={<Product />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/account" element={<Account />} />
                <Route path="/wishlist" element={<Wishlist />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/search" element={<Search />} />
              </Routes>
            </div>
            <Footer />
            <CartDrawer />
            <BackToTop />
            <Toaster position="bottom-right" richColors closeButton toastOptions={{ style: { fontFamily: "Manrope" } }} />
          </BrowserRouter>
          </WishlistProvider>
        </CartProvider>
      </AuthProvider>
      </CatalogGate>
    </div>
  );
}

export default App;
